/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import { useDispatch } from 'react-redux';

// Formik
import { Formik } from 'formik';

// Yup Schema
import { fareSchema } from 'yupSchemas/fareSchema';

// Material
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

// Actions
import * as FaresActions from 'store/ducks/fares/actions';

// Components
import { MaskedInputCurrency } from 'components/MaskedInputs';
import MASKS from 'constants/masks';

// Mask
import InputMask from 'react-input-mask';

// Styles
import useStyles from './FormFare.styles';

const FormFare: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const storegeLimit =
    JSON.parse(window.localStorage.getItem('persist:root') as string)
      ?.localLimit || '10';
  const { localLimit } = JSON.parse(storegeLimit) || 10;

  return (
    <>
      <Typography variant='h4'>Nova Tarifa</Typography>
      <Formik
        initialValues={{
          value: 0,
          startDate: '',
          endDate: '',
          name: '',
        }}
        onSubmit={(values) => {
          dispatch(
            FaresActions.createFareRequest(
              {
                value: values.value,
                startDate: values.startDate,
                endDate: values.endDate,
                name: values.name,
              },
              {
                action: FaresActions.listFaresRequest,
                payload: { _limit: 9999 },
              },
            ),
          );
        }}
        validationSchema={fareSchema}>
        {(props) => {
          const {
            values,
            handleSubmit,
            handleChange,
            handleBlur,
            errors,
            touched,
          } = props;
          return (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item lg={6} md={6} sm={12} xl={6} xs={12}>
                  <TextField
                    error={Boolean(errors.name && touched.name)}
                    fullWidth
                    helperText={errors.name && touched.name && errors.name}
                    id='text-field-name'
                    label='Nome'
                    margin='normal'
                    name='name'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.name}
                    variant='outlined'
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xl={6} xs={12}>
                  <TextField
                    InputProps={{
                      inputComponent: MaskedInputCurrency as any,
                    }}
                    error={Boolean(errors.value && touched.value)}
                    fullWidth
                    helperText={errors.value && touched.value && errors.value}
                    id='text-field-value'
                    label='Valor'
                    margin='normal'
                    name='value'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.value}
                    variant='outlined'
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xl={6} xs={12}>
                  <InputMask
                    mask={MASKS.DATE}
                    name='startDate'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.startDate}>
                    {() => (
                      <TextField
                        error={Boolean(errors.startDate && touched.startDate)}
                        fullWidth
                        helperText={
                          errors.startDate &&
                          touched.startDate &&
                          errors.startDate
                        }
                        id='text-field-startDate'
                        label='Data de Início'
                        margin='normal'
                        name='startDate'
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.startDate}
                        variant='outlined'
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xl={6} xs={12}>
                  <InputMask
                    mask={MASKS.DATE}
                    name='endDate'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.endDate}>
                    {() => (
                      <TextField
                        error={Boolean(errors.endDate && touched.endDate)}
                        fullWidth
                        helperText={
                          errors.endDate && touched.endDate && errors.endDate
                        }
                        id='text-field-endDate'
                        label='Data de Final'
                        margin='normal'
                        name='endDate'
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.endDate}
                        variant='outlined'
                      />
                    )}
                  </InputMask>
                </Grid>
              </Grid>
              <Grid className={classes.rowButton} container spacing={2}>
                <Grid item lg={6} md={6} sm={12} xl={6} xs={12}>
                  <Button color='primary' type='submit' variant='contained'>
                    Criar
                  </Button>
                </Grid>
              </Grid>
            </form>
          );
        }}
      </Formik>
    </>
  );
};

export { FormFare };
export default FormFare;
